import axios from 'axios';
import { attachToken, attachUnauthorizedHandler } from './interceptors';

const clienteAxios= axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
    }
});

attachToken(clienteAxios);
attachUnauthorizedHandler(clienteAxios);

export default clienteAxios;